import React, { useState } from "react";
import Input from "../../../ui/common/Input";
import Button from "../../../ui/common/Button";
import { EditIcon, DeleteIcon, PlusIcon, SaveIcon, CloseIcon } from "../../../../icons/Icons";
import "./CustomMetricsModal.scss";


interface Metric {
  id: string;
  label: string;
  format: string;
}

const ID_PREFIX = "cs_";

const formats = [
  "number",
  "percentage",
  "time(m:ss)"
];

/**
 * CustomMetricsModal Component for managing Custom Metrics settings
 */
const CustomMetricsModal = ({ data, onSave, onClose }: any) => {
  
  const emptyMetric = {
    id: ID_PREFIX,
    label: "",
    format: "number"
  };

  const [metricEditIndex, setMetricEditIndex] = useState<number|null>(null);
  const [metricEditData, setMetricEditData] = useState<Metric>(emptyMetric);
  const [customMetrics, setCustomMetrics] = useState(data);

  /**
   * Updates metric form fields
   */
  const handleInputChange = (value, field) => {
    setMetricEditData({
      ...metricEditData,
      [field]: value,
    });
  };

  /**
   * Saves changes to metric
   */
  const handleMetricSave = () => {
    // if (!metricEditData.id || !metricEditData.label || !metricEditData.id.startsWith(ID_PREFIX)) {
    //   const updatedMetrics = customMetrics.filter((metric, key) => {
    //     return key !== metricEditIndex;
    //   });
    //   setCustomMetrics(updatedMetrics);
    //   setMetricEditIndex(null);
    //   return;
    // }

    const updatedMetrics = customMetrics.map((metric, key) => {
      if (key === metricEditIndex) {
        return {
          ...metricEditData,
        };
      }
      return metric;
    });

    setCustomMetrics(updatedMetrics);
    setMetricEditIndex(null);
  };
  
  /**
   * Cancels editing of a metric
   */
  const handleMetricCancel = () => {
    // Check if the id of the metric is empty, if so remove it from the list
    if (metricEditData.id === "") {
      const updatedMetrics = customMetrics.filter((metric, key) => {
        return key !== metricEditIndex;
      });
      setCustomMetrics(updatedMetrics);
    }
    setMetricEditIndex(null);
  };

  /**
   * Deletes a metric
   */
  const handleMetricDelete = (key) => {
    const updatedMetrics = customMetrics.filter((metric, index) => {
      return index !== key;
    });
    setCustomMetrics(updatedMetrics);
  };

  /**
   * Creates a new empty metric
   */
  const handleCreditNew = () => {
    // add empty metric to the list
    const updatedMetrics = [...customMetrics, emptyMetric];
    setCustomMetrics(updatedMetrics);
    setMetricEditIndex(customMetrics.length);
    setMetricEditData(emptyMetric);
  };

  /**
   * Saves custom metrics
   */
  const handleSave = () => {
    onSave([...customMetrics]);
  };

  return (
    <div className="cm-modal-wrapper">
      <h3>Custom Metrics settings</h3>

      <div className="metrics-container">
        <div className="metric-header">
          <div className="metric-id">
            <p>ID</p>
          </div>
          <div className="metric-label">
            <p>Label</p>
          </div>
          <div className="metric-format">
            <p>Format</p>
          </div>
          <div className="metric-buttons"></div>
        </div>
        <div className="metric-body">
          {Array.isArray(customMetrics) && customMetrics.map((metric, key) => (
            <div className="metric" key={key}>
              <div className="metric-id">
                {metricEditIndex === key ? (
                  <Input
                    type="text"
                    value={metricEditData?.id}
                    onChange={(e) => handleInputChange(e.target.value, "id")}
                  />
                ) : (
                  <p>{metric.id}</p>
                )}
              </div>
              <div className="metric-label">
                {metricEditIndex === key ? (
                  <Input
                    type="text"
                    value={metricEditData?.label}
                    onChange={(e) => handleInputChange(e.target.value, "label")}
                  />
                ) : (
                  <p>{metric.label}</p>
                )}
              </div>
              <div className="metric-format">
                {metricEditIndex === key ? (
                  <select value={metricEditData?.format} onChange={(e) => handleInputChange(e.target.value, "format")}>
                    {formats.map((format, i) => (
                      <option key={i} value={format}>{format}</option>
                    ))}
                  </select>
                ) : (
                  <p>{metric.format}</p>
                )}
              </div>
              <div className="metric-buttons">
                <Button
                  variant="success"
                  data-testid={`editButton${key}`}
                  size="small"
                  title="Save"
                  onClick={() => {
                    handleMetricSave();
                  }}
                  style={{ display: metricEditIndex === key ? "" : "none" }}
                >
                  <SaveIcon />
                </Button>

                <Button
                  variant="warning"
                  data-testid={`editButton${key}`}
                  size="small"
                  title="Cancel"
                  onClick={() => {
                    handleMetricCancel();
                  }}
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    display: metricEditIndex === key ? "" : "none",
                  }}
                >
                  <CloseIcon />
                </Button>

                <Button
                  variant="warning"
                  data-testid={`editButton${key}`}
                  size="small"
                  title="Edit"
                  onClick={() => {
                    setMetricEditData(metric);
                    setMetricEditIndex(key);
                  }}
                  // hide if editing
                  style={{ display: metricEditIndex === key ? "none" : "" }}
                >
                  <EditIcon />
                </Button>
                <Button
                  variant="danger"
                  data-testid={`deleteButton${key}`}
                  size="small"
                  title="Delete"
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    display: metricEditIndex === key ? "none" : "",
                  }}
                  onClick={() => {
                    handleMetricDelete(key);
                  }}
                >
                  <DeleteIcon />
                </Button>
              </div>
            </div>
          ))}
        </div>
        <div className="metric-footer">
          <Button
            variant="success"
            size="small"
            title={metricEditIndex !== null ? "First save or cancel editing" : "Add new metric"}
            style={{ marginLeft: "46%", marginRight: "47%" }}
            onClick={() => {
              handleCreditNew();
            }}
            disabled={metricEditIndex !== null}
          >
            <PlusIcon />
          </Button>
        </div>
      </div>

      <div className="sub-modal-actions">
        <Button
          variant="danger"
          onClick={() => {
            onClose();
          }}
        >
          Cancel
        </Button>
        <Button
          variant="success"
          onClick={() => {
            handleSave();
            onClose();
          }}
        >
          OK
        </Button>
      </div>
    </div>
  );
};

export default CustomMetricsModal;